// source: no/jotta/openapi/ref.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var no_jotta_openapi_federation_pb = require('../../../no/jotta/openapi/federation_pb.js');
goog.object.extend(proto, no_jotta_openapi_federation_pb);
var no_jotta_openapi_subscription_payment_v2_pb = require('../../../no/jotta/openapi/subscription/payment.v2_pb.js');
goog.object.extend(proto, no_jotta_openapi_subscription_payment_v2_pb);
goog.exportSymbol('proto.no.jotta.openapi.ArchiveRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.CommentRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.CommentRef.ItemCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.ContentRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.ContentRef.RefCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.ContentRefs', null, global);
goog.exportSymbol('proto.no.jotta.openapi.DeviceLoginCodeRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.EmailVerificationRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.ExternalLinkRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.FaceRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.FamilyInviteRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.FederatedIdentityRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.FileOrFolderRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.FileRevisionRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.HelpArticle', null, global);
goog.exportSymbol('proto.no.jotta.openapi.InstallationCodeRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.LoginFlowRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.OrderRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PasswordResetKeyRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PayPalFlowRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PhotoAlbumRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PhotoInAlbumRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PhotoRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PhotosRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PublicShareRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PurchaseRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PurchaseRef.Renew', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PurchaseRef.TypeCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.PurchaseRef.Upgrade', null, global);
goog.exportSymbol('proto.no.jotta.openapi.ResendVerificationEmailRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SettingsRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SettingsRef.Notifications', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SettingsRef.Notifications.Type', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SettingsRef.PaymentInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SettingsRef.SectionCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SettingsRef.Security', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SupportRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.SyncFolderRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.TrashRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.VippsFlowRef', null, global);
goog.exportSymbol('proto.no.jotta.openapi.VoucherRef', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.FileOrFolderRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.FileOrFolderRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.FileOrFolderRef.displayName = 'proto.no.jotta.openapi.FileOrFolderRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.FileRevisionRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.FileRevisionRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.FileRevisionRef.displayName = 'proto.no.jotta.openapi.FileRevisionRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PhotoRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PhotoRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PhotoRef.displayName = 'proto.no.jotta.openapi.PhotoRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.FaceRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.FaceRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.FaceRef.displayName = 'proto.no.jotta.openapi.FaceRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PhotoInAlbumRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PhotoInAlbumRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PhotoInAlbumRef.displayName = 'proto.no.jotta.openapi.PhotoInAlbumRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PhotoAlbumRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PhotoAlbumRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PhotoAlbumRef.displayName = 'proto.no.jotta.openapi.PhotoAlbumRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.CommentRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.CommentRef.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.CommentRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.CommentRef.displayName = 'proto.no.jotta.openapi.CommentRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.TrashRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.TrashRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.TrashRef.displayName = 'proto.no.jotta.openapi.TrashRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.ArchiveRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.ArchiveRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.ArchiveRef.displayName = 'proto.no.jotta.openapi.ArchiveRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.SyncFolderRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.SyncFolderRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.SyncFolderRef.displayName = 'proto.no.jotta.openapi.SyncFolderRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.SettingsRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.SettingsRef.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.SettingsRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.SettingsRef.displayName = 'proto.no.jotta.openapi.SettingsRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.SettingsRef.Notifications = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.SettingsRef.Notifications, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.SettingsRef.Notifications.displayName = 'proto.no.jotta.openapi.SettingsRef.Notifications';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.SettingsRef.Security = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.SettingsRef.Security, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.SettingsRef.Security.displayName = 'proto.no.jotta.openapi.SettingsRef.Security';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.SettingsRef.PaymentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.SettingsRef.PaymentInfo.displayName = 'proto.no.jotta.openapi.SettingsRef.PaymentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PurchaseRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.PurchaseRef.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.PurchaseRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PurchaseRef.displayName = 'proto.no.jotta.openapi.PurchaseRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PurchaseRef.Upgrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PurchaseRef.Upgrade.displayName = 'proto.no.jotta.openapi.PurchaseRef.Upgrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PurchaseRef.Renew = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PurchaseRef.Renew, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PurchaseRef.Renew.displayName = 'proto.no.jotta.openapi.PurchaseRef.Renew';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.OrderRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.OrderRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.OrderRef.displayName = 'proto.no.jotta.openapi.OrderRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PublicShareRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PublicShareRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PublicShareRef.displayName = 'proto.no.jotta.openapi.PublicShareRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.ExternalLinkRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.ExternalLinkRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.ExternalLinkRef.displayName = 'proto.no.jotta.openapi.ExternalLinkRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PhotosRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PhotosRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PhotosRef.displayName = 'proto.no.jotta.openapi.PhotosRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.HelpArticle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.HelpArticle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.HelpArticle.displayName = 'proto.no.jotta.openapi.HelpArticle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.FederatedIdentityRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.FederatedIdentityRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.FederatedIdentityRef.displayName = 'proto.no.jotta.openapi.FederatedIdentityRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.VippsFlowRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.VippsFlowRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.VippsFlowRef.displayName = 'proto.no.jotta.openapi.VippsFlowRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PayPalFlowRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PayPalFlowRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PayPalFlowRef.displayName = 'proto.no.jotta.openapi.PayPalFlowRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.FamilyInviteRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.FamilyInviteRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.FamilyInviteRef.displayName = 'proto.no.jotta.openapi.FamilyInviteRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.VoucherRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.VoucherRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.VoucherRef.displayName = 'proto.no.jotta.openapi.VoucherRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.ResendVerificationEmailRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.ResendVerificationEmailRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.ResendVerificationEmailRef.displayName = 'proto.no.jotta.openapi.ResendVerificationEmailRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.EmailVerificationRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.EmailVerificationRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.EmailVerificationRef.displayName = 'proto.no.jotta.openapi.EmailVerificationRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.PasswordResetKeyRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.PasswordResetKeyRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.PasswordResetKeyRef.displayName = 'proto.no.jotta.openapi.PasswordResetKeyRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.DeviceLoginCodeRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.DeviceLoginCodeRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.DeviceLoginCodeRef.displayName = 'proto.no.jotta.openapi.DeviceLoginCodeRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.LoginFlowRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.LoginFlowRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.LoginFlowRef.displayName = 'proto.no.jotta.openapi.LoginFlowRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.InstallationCodeRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.InstallationCodeRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.InstallationCodeRef.displayName = 'proto.no.jotta.openapi.InstallationCodeRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.SupportRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.SupportRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.SupportRef.displayName = 'proto.no.jotta.openapi.SupportRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.ContentRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.ContentRef.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.ContentRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.ContentRef.displayName = 'proto.no.jotta.openapi.ContentRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.ContentRefs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.ContentRefs.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.ContentRefs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.ContentRefs.displayName = 'proto.no.jotta.openapi.ContentRefs';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.FileOrFolderRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.FileOrFolderRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.FileOrFolderRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FileOrFolderRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.FileOrFolderRef}
 */
proto.no.jotta.openapi.FileOrFolderRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.FileOrFolderRef;
  return proto.no.jotta.openapi.FileOrFolderRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.FileOrFolderRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.FileOrFolderRef}
 */
proto.no.jotta.openapi.FileOrFolderRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.FileOrFolderRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.FileOrFolderRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.FileOrFolderRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FileOrFolderRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.FileOrFolderRef.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FileOrFolderRef} returns this
 */
proto.no.jotta.openapi.FileOrFolderRef.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.FileRevisionRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.FileRevisionRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FileRevisionRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    checksum: jspb.Message.getFieldWithDefault(msg, 2, ""),
    path: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.FileRevisionRef}
 */
proto.no.jotta.openapi.FileRevisionRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.FileRevisionRef;
  return proto.no.jotta.openapi.FileRevisionRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.FileRevisionRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.FileRevisionRef}
 */
proto.no.jotta.openapi.FileRevisionRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.FileRevisionRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.FileRevisionRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FileRevisionRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FileRevisionRef} returns this
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string checksum = 2;
 * @return {string}
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FileRevisionRef} returns this
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FileRevisionRef} returns this
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.setPath = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.FileRevisionRef} returns this
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.clearPath = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.FileRevisionRef.prototype.hasPath = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PhotoRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PhotoRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PhotoRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotoRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    checksum: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PhotoRef}
 */
proto.no.jotta.openapi.PhotoRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PhotoRef;
  return proto.no.jotta.openapi.PhotoRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PhotoRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PhotoRef}
 */
proto.no.jotta.openapi.PhotoRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PhotoRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PhotoRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PhotoRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotoRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoRef.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoRef} returns this
 */
proto.no.jotta.openapi.PhotoRef.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string checksum = 2;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoRef.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoRef} returns this
 */
proto.no.jotta.openapi.PhotoRef.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.FaceRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.FaceRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.FaceRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FaceRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    checksum: jspb.Message.getFieldWithDefault(msg, 2, ""),
    left: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    top: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    right: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    bottom: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.FaceRef}
 */
proto.no.jotta.openapi.FaceRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.FaceRef;
  return proto.no.jotta.openapi.FaceRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.FaceRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.FaceRef}
 */
proto.no.jotta.openapi.FaceRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLeft(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTop(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRight(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBottom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.FaceRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.FaceRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.FaceRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FaceRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLeft();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTop();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getRight();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getBottom();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.openapi.FaceRef.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FaceRef} returns this
 */
proto.no.jotta.openapi.FaceRef.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string checksum = 2;
 * @return {string}
 */
proto.no.jotta.openapi.FaceRef.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FaceRef} returns this
 */
proto.no.jotta.openapi.FaceRef.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double left = 3;
 * @return {number}
 */
proto.no.jotta.openapi.FaceRef.prototype.getLeft = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.FaceRef} returns this
 */
proto.no.jotta.openapi.FaceRef.prototype.setLeft = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double top = 4;
 * @return {number}
 */
proto.no.jotta.openapi.FaceRef.prototype.getTop = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.FaceRef} returns this
 */
proto.no.jotta.openapi.FaceRef.prototype.setTop = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double right = 5;
 * @return {number}
 */
proto.no.jotta.openapi.FaceRef.prototype.getRight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.FaceRef} returns this
 */
proto.no.jotta.openapi.FaceRef.prototype.setRight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double bottom = 6;
 * @return {number}
 */
proto.no.jotta.openapi.FaceRef.prototype.getBottom = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.FaceRef} returns this
 */
proto.no.jotta.openapi.FaceRef.prototype.setBottom = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PhotoInAlbumRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PhotoInAlbumRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotoInAlbumRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    photoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    albumId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    shareId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    photo: (f = msg.getPhoto()) && proto.no.jotta.openapi.PhotoRef.toObject(includeInstance, f),
    index: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PhotoInAlbumRef;
  return proto.no.jotta.openapi.PhotoInAlbumRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PhotoInAlbumRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhotoId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlbumId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareId(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.PhotoRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotoRef.deserializeBinaryFromReader);
      msg.setPhoto(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PhotoInAlbumRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PhotoInAlbumRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotoInAlbumRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhotoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAlbumId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShareId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhoto();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.no.jotta.openapi.PhotoRef.serializeBinaryToWriter
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string photo_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.getPhotoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.setPhotoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string album_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.getAlbumId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.setAlbumId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string share_id = 3;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.getShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.setShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional PhotoRef photo = 4;
 * @return {?proto.no.jotta.openapi.PhotoRef}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.getPhoto = function() {
  return /** @type{?proto.no.jotta.openapi.PhotoRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotoRef, 4));
};


/**
 * @param {?proto.no.jotta.openapi.PhotoRef|undefined} value
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef} returns this
*/
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.setPhoto = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.clearPhoto = function() {
  return this.setPhoto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.hasPhoto = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 index = 5;
 * @return {number}
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.PhotoInAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoInAlbumRef.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PhotoAlbumRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PhotoAlbumRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PhotoAlbumRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotoAlbumRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shareId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PhotoAlbumRef}
 */
proto.no.jotta.openapi.PhotoAlbumRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PhotoAlbumRef;
  return proto.no.jotta.openapi.PhotoAlbumRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PhotoAlbumRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PhotoAlbumRef}
 */
proto.no.jotta.openapi.PhotoAlbumRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PhotoAlbumRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PhotoAlbumRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PhotoAlbumRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotoAlbumRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShareId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoAlbumRef.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoAlbumRef.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string share_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.PhotoAlbumRef.prototype.getShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PhotoAlbumRef} returns this
 */
proto.no.jotta.openapi.PhotoAlbumRef.prototype.setShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.CommentRef.oneofGroups_ = [[100,101]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.CommentRef.ItemCase = {
  ITEM_NOT_SET: 0,
  PHOTO_IN_ALBUM: 100,
  PHOTO_ALBUM: 101
};

/**
 * @return {proto.no.jotta.openapi.CommentRef.ItemCase}
 */
proto.no.jotta.openapi.CommentRef.prototype.getItemCase = function() {
  return /** @type {proto.no.jotta.openapi.CommentRef.ItemCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.CommentRef.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.CommentRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.CommentRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.CommentRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.CommentRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    photoInAlbum: (f = msg.getPhotoInAlbum()) && proto.no.jotta.openapi.PhotoInAlbumRef.toObject(includeInstance, f),
    photoAlbum: (f = msg.getPhotoAlbum()) && proto.no.jotta.openapi.PhotoAlbumRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.CommentRef}
 */
proto.no.jotta.openapi.CommentRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.CommentRef;
  return proto.no.jotta.openapi.CommentRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.CommentRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.CommentRef}
 */
proto.no.jotta.openapi.CommentRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 100:
      var value = new proto.no.jotta.openapi.PhotoInAlbumRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotoInAlbumRef.deserializeBinaryFromReader);
      msg.setPhotoInAlbum(value);
      break;
    case 101:
      var value = new proto.no.jotta.openapi.PhotoAlbumRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotoAlbumRef.deserializeBinaryFromReader);
      msg.setPhotoAlbum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.CommentRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.CommentRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.CommentRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.CommentRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhotoInAlbum();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.no.jotta.openapi.PhotoInAlbumRef.serializeBinaryToWriter
    );
  }
  f = message.getPhotoAlbum();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.no.jotta.openapi.PhotoAlbumRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.CommentRef.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.CommentRef} returns this
 */
proto.no.jotta.openapi.CommentRef.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string parent_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.CommentRef.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.CommentRef} returns this
 */
proto.no.jotta.openapi.CommentRef.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PhotoInAlbumRef photo_in_album = 100;
 * @return {?proto.no.jotta.openapi.PhotoInAlbumRef}
 */
proto.no.jotta.openapi.CommentRef.prototype.getPhotoInAlbum = function() {
  return /** @type{?proto.no.jotta.openapi.PhotoInAlbumRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotoInAlbumRef, 100));
};


/**
 * @param {?proto.no.jotta.openapi.PhotoInAlbumRef|undefined} value
 * @return {!proto.no.jotta.openapi.CommentRef} returns this
*/
proto.no.jotta.openapi.CommentRef.prototype.setPhotoInAlbum = function(value) {
  return jspb.Message.setOneofWrapperField(this, 100, proto.no.jotta.openapi.CommentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.CommentRef} returns this
 */
proto.no.jotta.openapi.CommentRef.prototype.clearPhotoInAlbum = function() {
  return this.setPhotoInAlbum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.CommentRef.prototype.hasPhotoInAlbum = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional PhotoAlbumRef photo_album = 101;
 * @return {?proto.no.jotta.openapi.PhotoAlbumRef}
 */
proto.no.jotta.openapi.CommentRef.prototype.getPhotoAlbum = function() {
  return /** @type{?proto.no.jotta.openapi.PhotoAlbumRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotoAlbumRef, 101));
};


/**
 * @param {?proto.no.jotta.openapi.PhotoAlbumRef|undefined} value
 * @return {!proto.no.jotta.openapi.CommentRef} returns this
*/
proto.no.jotta.openapi.CommentRef.prototype.setPhotoAlbum = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.no.jotta.openapi.CommentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.CommentRef} returns this
 */
proto.no.jotta.openapi.CommentRef.prototype.clearPhotoAlbum = function() {
  return this.setPhotoAlbum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.CommentRef.prototype.hasPhotoAlbum = function() {
  return jspb.Message.getField(this, 101) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.TrashRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.TrashRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.TrashRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.TrashRef.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.TrashRef}
 */
proto.no.jotta.openapi.TrashRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.TrashRef;
  return proto.no.jotta.openapi.TrashRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.TrashRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.TrashRef}
 */
proto.no.jotta.openapi.TrashRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.TrashRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.TrashRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.TrashRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.TrashRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.ArchiveRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.ArchiveRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.ArchiveRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ArchiveRef.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.ArchiveRef}
 */
proto.no.jotta.openapi.ArchiveRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.ArchiveRef;
  return proto.no.jotta.openapi.ArchiveRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.ArchiveRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.ArchiveRef}
 */
proto.no.jotta.openapi.ArchiveRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.ArchiveRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.ArchiveRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.ArchiveRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ArchiveRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.SyncFolderRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.SyncFolderRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.SyncFolderRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SyncFolderRef.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.SyncFolderRef}
 */
proto.no.jotta.openapi.SyncFolderRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.SyncFolderRef;
  return proto.no.jotta.openapi.SyncFolderRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.SyncFolderRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.SyncFolderRef}
 */
proto.no.jotta.openapi.SyncFolderRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.SyncFolderRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.SyncFolderRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.SyncFolderRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SyncFolderRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.SettingsRef.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.SettingsRef.SectionCase = {
  SECTION_NOT_SET: 0,
  NOTIFICATIONS: 1,
  SECURITY: 2,
  PAYMENT_INFO: 3
};

/**
 * @return {proto.no.jotta.openapi.SettingsRef.SectionCase}
 */
proto.no.jotta.openapi.SettingsRef.prototype.getSectionCase = function() {
  return /** @type {proto.no.jotta.openapi.SettingsRef.SectionCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.SettingsRef.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.SettingsRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.SettingsRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.SettingsRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    notifications: (f = msg.getNotifications()) && proto.no.jotta.openapi.SettingsRef.Notifications.toObject(includeInstance, f),
    security: (f = msg.getSecurity()) && proto.no.jotta.openapi.SettingsRef.Security.toObject(includeInstance, f),
    paymentInfo: (f = msg.getPaymentInfo()) && proto.no.jotta.openapi.SettingsRef.PaymentInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.SettingsRef}
 */
proto.no.jotta.openapi.SettingsRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.SettingsRef;
  return proto.no.jotta.openapi.SettingsRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.SettingsRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.SettingsRef}
 */
proto.no.jotta.openapi.SettingsRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.SettingsRef.Notifications;
      reader.readMessage(value,proto.no.jotta.openapi.SettingsRef.Notifications.deserializeBinaryFromReader);
      msg.setNotifications(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.SettingsRef.Security;
      reader.readMessage(value,proto.no.jotta.openapi.SettingsRef.Security.deserializeBinaryFromReader);
      msg.setSecurity(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.SettingsRef.PaymentInfo;
      reader.readMessage(value,proto.no.jotta.openapi.SettingsRef.PaymentInfo.deserializeBinaryFromReader);
      msg.setPaymentInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.SettingsRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.SettingsRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.SettingsRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotifications();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.SettingsRef.Notifications.serializeBinaryToWriter
    );
  }
  f = message.getSecurity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.SettingsRef.Security.serializeBinaryToWriter
    );
  }
  f = message.getPaymentInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.SettingsRef.PaymentInfo.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.SettingsRef.Notifications.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.SettingsRef.Notifications.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.SettingsRef.Notifications} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.Notifications.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.SettingsRef.Notifications}
 */
proto.no.jotta.openapi.SettingsRef.Notifications.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.SettingsRef.Notifications;
  return proto.no.jotta.openapi.SettingsRef.Notifications.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.SettingsRef.Notifications} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.SettingsRef.Notifications}
 */
proto.no.jotta.openapi.SettingsRef.Notifications.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.SettingsRef.Notifications.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.SettingsRef.Notifications.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.SettingsRef.Notifications} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.Notifications.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.SettingsRef.Notifications.Type = {
  UNKNOWN_NOTIFICATION_SETTING: 0,
  NEWSLETTER: 1,
  EXCESSIVE_TRASH: 2,
  APP_NOTIFICATIONS: 3,
  EMAIL_NOTIFICATIONS: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.SettingsRef.Security.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.SettingsRef.Security.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.SettingsRef.Security} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.Security.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.SettingsRef.Security}
 */
proto.no.jotta.openapi.SettingsRef.Security.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.SettingsRef.Security;
  return proto.no.jotta.openapi.SettingsRef.Security.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.SettingsRef.Security} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.SettingsRef.Security}
 */
proto.no.jotta.openapi.SettingsRef.Security.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.SettingsRef.Security.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.SettingsRef.Security.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.SettingsRef.Security} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.Security.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.SettingsRef.PaymentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.SettingsRef.PaymentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.SettingsRef.PaymentInfo}
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.SettingsRef.PaymentInfo;
  return proto.no.jotta.openapi.SettingsRef.PaymentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.SettingsRef.PaymentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.SettingsRef.PaymentInfo}
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.SettingsRef.PaymentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.SettingsRef.PaymentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SettingsRef.PaymentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Notifications notifications = 1;
 * @return {?proto.no.jotta.openapi.SettingsRef.Notifications}
 */
proto.no.jotta.openapi.SettingsRef.prototype.getNotifications = function() {
  return /** @type{?proto.no.jotta.openapi.SettingsRef.Notifications} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.SettingsRef.Notifications, 1));
};


/**
 * @param {?proto.no.jotta.openapi.SettingsRef.Notifications|undefined} value
 * @return {!proto.no.jotta.openapi.SettingsRef} returns this
*/
proto.no.jotta.openapi.SettingsRef.prototype.setNotifications = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.SettingsRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.SettingsRef} returns this
 */
proto.no.jotta.openapi.SettingsRef.prototype.clearNotifications = function() {
  return this.setNotifications(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.SettingsRef.prototype.hasNotifications = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Security security = 2;
 * @return {?proto.no.jotta.openapi.SettingsRef.Security}
 */
proto.no.jotta.openapi.SettingsRef.prototype.getSecurity = function() {
  return /** @type{?proto.no.jotta.openapi.SettingsRef.Security} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.SettingsRef.Security, 2));
};


/**
 * @param {?proto.no.jotta.openapi.SettingsRef.Security|undefined} value
 * @return {!proto.no.jotta.openapi.SettingsRef} returns this
*/
proto.no.jotta.openapi.SettingsRef.prototype.setSecurity = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.SettingsRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.SettingsRef} returns this
 */
proto.no.jotta.openapi.SettingsRef.prototype.clearSecurity = function() {
  return this.setSecurity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.SettingsRef.prototype.hasSecurity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PaymentInfo payment_info = 3;
 * @return {?proto.no.jotta.openapi.SettingsRef.PaymentInfo}
 */
proto.no.jotta.openapi.SettingsRef.prototype.getPaymentInfo = function() {
  return /** @type{?proto.no.jotta.openapi.SettingsRef.PaymentInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.SettingsRef.PaymentInfo, 3));
};


/**
 * @param {?proto.no.jotta.openapi.SettingsRef.PaymentInfo|undefined} value
 * @return {!proto.no.jotta.openapi.SettingsRef} returns this
*/
proto.no.jotta.openapi.SettingsRef.prototype.setPaymentInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.no.jotta.openapi.SettingsRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.SettingsRef} returns this
 */
proto.no.jotta.openapi.SettingsRef.prototype.clearPaymentInfo = function() {
  return this.setPaymentInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.SettingsRef.prototype.hasPaymentInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.PurchaseRef.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.PurchaseRef.TypeCase = {
  TYPE_NOT_SET: 0,
  UPGRADE: 1,
  RENEW: 2
};

/**
 * @return {proto.no.jotta.openapi.PurchaseRef.TypeCase}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.getTypeCase = function() {
  return /** @type {proto.no.jotta.openapi.PurchaseRef.TypeCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.PurchaseRef.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PurchaseRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PurchaseRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PurchaseRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    upgrade: (f = msg.getUpgrade()) && proto.no.jotta.openapi.PurchaseRef.Upgrade.toObject(includeInstance, f),
    renew: (f = msg.getRenew()) && proto.no.jotta.openapi.PurchaseRef.Renew.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PurchaseRef}
 */
proto.no.jotta.openapi.PurchaseRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PurchaseRef;
  return proto.no.jotta.openapi.PurchaseRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PurchaseRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PurchaseRef}
 */
proto.no.jotta.openapi.PurchaseRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.PurchaseRef.Upgrade;
      reader.readMessage(value,proto.no.jotta.openapi.PurchaseRef.Upgrade.deserializeBinaryFromReader);
      msg.setUpgrade(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.PurchaseRef.Renew;
      reader.readMessage(value,proto.no.jotta.openapi.PurchaseRef.Renew.deserializeBinaryFromReader);
      msg.setRenew(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PurchaseRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PurchaseRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PurchaseRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpgrade();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.PurchaseRef.Upgrade.serializeBinaryToWriter
    );
  }
  f = message.getRenew();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.PurchaseRef.Renew.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PurchaseRef.Upgrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PurchaseRef.Upgrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.toObject = function(includeInstance, msg) {
  var f, obj = {
    productCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PurchaseRef.Upgrade}
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PurchaseRef.Upgrade;
  return proto.no.jotta.openapi.PurchaseRef.Upgrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PurchaseRef.Upgrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PurchaseRef.Upgrade}
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PurchaseRef.Upgrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PurchaseRef.Upgrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string product_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.prototype.getProductCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PurchaseRef.Upgrade} returns this
 */
proto.no.jotta.openapi.PurchaseRef.Upgrade.prototype.setProductCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PurchaseRef.Renew.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PurchaseRef.Renew.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PurchaseRef.Renew} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PurchaseRef.Renew.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PurchaseRef.Renew}
 */
proto.no.jotta.openapi.PurchaseRef.Renew.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PurchaseRef.Renew;
  return proto.no.jotta.openapi.PurchaseRef.Renew.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PurchaseRef.Renew} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PurchaseRef.Renew}
 */
proto.no.jotta.openapi.PurchaseRef.Renew.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PurchaseRef.Renew.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PurchaseRef.Renew.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PurchaseRef.Renew} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PurchaseRef.Renew.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Upgrade upgrade = 1;
 * @return {?proto.no.jotta.openapi.PurchaseRef.Upgrade}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.getUpgrade = function() {
  return /** @type{?proto.no.jotta.openapi.PurchaseRef.Upgrade} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PurchaseRef.Upgrade, 1));
};


/**
 * @param {?proto.no.jotta.openapi.PurchaseRef.Upgrade|undefined} value
 * @return {!proto.no.jotta.openapi.PurchaseRef} returns this
*/
proto.no.jotta.openapi.PurchaseRef.prototype.setUpgrade = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.PurchaseRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.PurchaseRef} returns this
 */
proto.no.jotta.openapi.PurchaseRef.prototype.clearUpgrade = function() {
  return this.setUpgrade(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.hasUpgrade = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Renew renew = 2;
 * @return {?proto.no.jotta.openapi.PurchaseRef.Renew}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.getRenew = function() {
  return /** @type{?proto.no.jotta.openapi.PurchaseRef.Renew} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PurchaseRef.Renew, 2));
};


/**
 * @param {?proto.no.jotta.openapi.PurchaseRef.Renew|undefined} value
 * @return {!proto.no.jotta.openapi.PurchaseRef} returns this
*/
proto.no.jotta.openapi.PurchaseRef.prototype.setRenew = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.PurchaseRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.PurchaseRef} returns this
 */
proto.no.jotta.openapi.PurchaseRef.prototype.clearRenew = function() {
  return this.setRenew(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.PurchaseRef.prototype.hasRenew = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.OrderRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.OrderRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.OrderRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.OrderRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.OrderRef}
 */
proto.no.jotta.openapi.OrderRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.OrderRef;
  return proto.no.jotta.openapi.OrderRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.OrderRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.OrderRef}
 */
proto.no.jotta.openapi.OrderRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.OrderRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.OrderRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.OrderRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.OrderRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.OrderRef.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.OrderRef} returns this
 */
proto.no.jotta.openapi.OrderRef.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PublicShareRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PublicShareRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PublicShareRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PublicShareRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    path: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PublicShareRef}
 */
proto.no.jotta.openapi.PublicShareRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PublicShareRef;
  return proto.no.jotta.openapi.PublicShareRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PublicShareRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PublicShareRef}
 */
proto.no.jotta.openapi.PublicShareRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PublicShareRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PublicShareRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PublicShareRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PublicShareRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string share_id = 3;
 * @return {string}
 */
proto.no.jotta.openapi.PublicShareRef.prototype.getShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PublicShareRef} returns this
 */
proto.no.jotta.openapi.PublicShareRef.prototype.setShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string path = 4;
 * @return {string}
 */
proto.no.jotta.openapi.PublicShareRef.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PublicShareRef} returns this
 */
proto.no.jotta.openapi.PublicShareRef.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.ExternalLinkRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.ExternalLinkRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.ExternalLinkRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ExternalLinkRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    link: jspb.Message.getFieldWithDefault(msg, 1, ""),
    signature: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.ExternalLinkRef}
 */
proto.no.jotta.openapi.ExternalLinkRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.ExternalLinkRef;
  return proto.no.jotta.openapi.ExternalLinkRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.ExternalLinkRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.ExternalLinkRef}
 */
proto.no.jotta.openapi.ExternalLinkRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.ExternalLinkRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.ExternalLinkRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.ExternalLinkRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ExternalLinkRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSignature();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string link = 1;
 * @return {string}
 */
proto.no.jotta.openapi.ExternalLinkRef.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.ExternalLinkRef} returns this
 */
proto.no.jotta.openapi.ExternalLinkRef.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string signature = 2;
 * @return {string}
 */
proto.no.jotta.openapi.ExternalLinkRef.prototype.getSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.ExternalLinkRef} returns this
 */
proto.no.jotta.openapi.ExternalLinkRef.prototype.setSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PhotosRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PhotosRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PhotosRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotosRef.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PhotosRef}
 */
proto.no.jotta.openapi.PhotosRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PhotosRef;
  return proto.no.jotta.openapi.PhotosRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PhotosRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PhotosRef}
 */
proto.no.jotta.openapi.PhotosRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PhotosRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PhotosRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PhotosRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PhotosRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.HelpArticle.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.HelpArticle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.HelpArticle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.HelpArticle.toObject = function(includeInstance, msg) {
  var f, obj = {
    articleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.HelpArticle}
 */
proto.no.jotta.openapi.HelpArticle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.HelpArticle;
  return proto.no.jotta.openapi.HelpArticle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.HelpArticle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.HelpArticle}
 */
proto.no.jotta.openapi.HelpArticle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setArticleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.HelpArticle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.HelpArticle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.HelpArticle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.HelpArticle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getArticleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string article_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.HelpArticle.prototype.getArticleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.HelpArticle} returns this
 */
proto.no.jotta.openapi.HelpArticle.prototype.setArticleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.FederatedIdentityRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.FederatedIdentityRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FederatedIdentityRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    intent: (f = msg.getIntent()) && no_jotta_openapi_federation_pb.FederationIntent.toObject(includeInstance, f),
    providerId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.FederatedIdentityRef}
 */
proto.no.jotta.openapi.FederatedIdentityRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.FederatedIdentityRef;
  return proto.no.jotta.openapi.FederatedIdentityRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.FederatedIdentityRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.FederatedIdentityRef}
 */
proto.no.jotta.openapi.FederatedIdentityRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = new no_jotta_openapi_federation_pb.FederationIntent;
      reader.readMessage(value,no_jotta_openapi_federation_pb.FederationIntent.deserializeBinaryFromReader);
      msg.setIntent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.FederatedIdentityRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.FederatedIdentityRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FederatedIdentityRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      no_jotta_openapi_federation_pb.FederationIntent.serializeBinaryToWriter
    );
  }
  f = message.getProviderId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FederatedIdentityRef} returns this
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FederationIntent intent = 2;
 * @return {?proto.no.jotta.openapi.FederationIntent}
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.getIntent = function() {
  return /** @type{?proto.no.jotta.openapi.FederationIntent} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_federation_pb.FederationIntent, 2));
};


/**
 * @param {?proto.no.jotta.openapi.FederationIntent|undefined} value
 * @return {!proto.no.jotta.openapi.FederatedIdentityRef} returns this
*/
proto.no.jotta.openapi.FederatedIdentityRef.prototype.setIntent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.FederatedIdentityRef} returns this
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.clearIntent = function() {
  return this.setIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.hasIntent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string provider_id = 3;
 * @return {string}
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.getProviderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FederatedIdentityRef} returns this
 */
proto.no.jotta.openapi.FederatedIdentityRef.prototype.setProviderId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.VippsFlowRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.VippsFlowRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.VippsFlowRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.VippsFlowRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    flowId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.VippsFlowRef}
 */
proto.no.jotta.openapi.VippsFlowRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.VippsFlowRef;
  return proto.no.jotta.openapi.VippsFlowRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.VippsFlowRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.VippsFlowRef}
 */
proto.no.jotta.openapi.VippsFlowRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlowId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.VippsFlowRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.VippsFlowRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.VippsFlowRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.VippsFlowRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlowId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string flow_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.VippsFlowRef.prototype.getFlowId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.VippsFlowRef} returns this
 */
proto.no.jotta.openapi.VippsFlowRef.prototype.setFlowId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PayPalFlowRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PayPalFlowRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PayPalFlowRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientState: (f = msg.getClientState()) && no_jotta_openapi_subscription_payment_v2_pb.StripeClientState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PayPalFlowRef}
 */
proto.no.jotta.openapi.PayPalFlowRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PayPalFlowRef;
  return proto.no.jotta.openapi.PayPalFlowRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PayPalFlowRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PayPalFlowRef}
 */
proto.no.jotta.openapi.PayPalFlowRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderNumber(value);
      break;
    case 2:
      var value = new no_jotta_openapi_subscription_payment_v2_pb.StripeClientState;
      reader.readMessage(value,no_jotta_openapi_subscription_payment_v2_pb.StripeClientState.deserializeBinaryFromReader);
      msg.setClientState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PayPalFlowRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PayPalFlowRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PayPalFlowRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      no_jotta_openapi_subscription_payment_v2_pb.StripeClientState.serializeBinaryToWriter
    );
  }
};


/**
 * optional string order_number = 1;
 * @return {string}
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.getOrderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PayPalFlowRef} returns this
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.setOrderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional subscription.v2.StripeClientState client_state = 2;
 * @return {?proto.no.jotta.openapi.subscription.v2.StripeClientState}
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.getClientState = function() {
  return /** @type{?proto.no.jotta.openapi.subscription.v2.StripeClientState} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_subscription_payment_v2_pb.StripeClientState, 2));
};


/**
 * @param {?proto.no.jotta.openapi.subscription.v2.StripeClientState|undefined} value
 * @return {!proto.no.jotta.openapi.PayPalFlowRef} returns this
*/
proto.no.jotta.openapi.PayPalFlowRef.prototype.setClientState = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.PayPalFlowRef} returns this
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.clearClientState = function() {
  return this.setClientState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.PayPalFlowRef.prototype.hasClientState = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.FamilyInviteRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.FamilyInviteRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.FamilyInviteRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FamilyInviteRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.FamilyInviteRef}
 */
proto.no.jotta.openapi.FamilyInviteRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.FamilyInviteRef;
  return proto.no.jotta.openapi.FamilyInviteRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.FamilyInviteRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.FamilyInviteRef}
 */
proto.no.jotta.openapi.FamilyInviteRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.FamilyInviteRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.FamilyInviteRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.FamilyInviteRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.FamilyInviteRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invite_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.FamilyInviteRef.prototype.getInviteCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.FamilyInviteRef} returns this
 */
proto.no.jotta.openapi.FamilyInviteRef.prototype.setInviteCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.VoucherRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.VoucherRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.VoucherRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.VoucherRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    voucherCode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.VoucherRef}
 */
proto.no.jotta.openapi.VoucherRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.VoucherRef;
  return proto.no.jotta.openapi.VoucherRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.VoucherRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.VoucherRef}
 */
proto.no.jotta.openapi.VoucherRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVoucherCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.VoucherRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.VoucherRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.VoucherRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.VoucherRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVoucherCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string voucher_code = 2;
 * @return {string}
 */
proto.no.jotta.openapi.VoucherRef.prototype.getVoucherCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.VoucherRef} returns this
 */
proto.no.jotta.openapi.VoucherRef.prototype.setVoucherCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.ResendVerificationEmailRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.ResendVerificationEmailRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.ResendVerificationEmailRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ResendVerificationEmailRef.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.ResendVerificationEmailRef}
 */
proto.no.jotta.openapi.ResendVerificationEmailRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.ResendVerificationEmailRef;
  return proto.no.jotta.openapi.ResendVerificationEmailRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.ResendVerificationEmailRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.ResendVerificationEmailRef}
 */
proto.no.jotta.openapi.ResendVerificationEmailRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.ResendVerificationEmailRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.ResendVerificationEmailRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.ResendVerificationEmailRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ResendVerificationEmailRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.EmailVerificationRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.EmailVerificationRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.EmailVerificationRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.EmailVerificationRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    verificationCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.EmailVerificationRef}
 */
proto.no.jotta.openapi.EmailVerificationRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.EmailVerificationRef;
  return proto.no.jotta.openapi.EmailVerificationRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.EmailVerificationRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.EmailVerificationRef}
 */
proto.no.jotta.openapi.EmailVerificationRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVerificationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.EmailVerificationRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.EmailVerificationRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.EmailVerificationRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.EmailVerificationRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string verification_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.EmailVerificationRef.prototype.getVerificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.EmailVerificationRef} returns this
 */
proto.no.jotta.openapi.EmailVerificationRef.prototype.setVerificationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.PasswordResetKeyRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.PasswordResetKeyRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.PasswordResetKeyRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PasswordResetKeyRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    resetKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.PasswordResetKeyRef}
 */
proto.no.jotta.openapi.PasswordResetKeyRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.PasswordResetKeyRef;
  return proto.no.jotta.openapi.PasswordResetKeyRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.PasswordResetKeyRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.PasswordResetKeyRef}
 */
proto.no.jotta.openapi.PasswordResetKeyRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResetKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.PasswordResetKeyRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.PasswordResetKeyRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.PasswordResetKeyRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.PasswordResetKeyRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResetKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reset_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.PasswordResetKeyRef.prototype.getResetKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.PasswordResetKeyRef} returns this
 */
proto.no.jotta.openapi.PasswordResetKeyRef.prototype.setResetKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.DeviceLoginCodeRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.DeviceLoginCodeRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.DeviceLoginCodeRef}
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.DeviceLoginCodeRef;
  return proto.no.jotta.openapi.DeviceLoginCodeRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.DeviceLoginCodeRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.DeviceLoginCodeRef}
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.DeviceLoginCodeRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.DeviceLoginCodeRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.DeviceLoginCodeRef} returns this
 */
proto.no.jotta.openapi.DeviceLoginCodeRef.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.LoginFlowRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.LoginFlowRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.LoginFlowRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.LoginFlowRef}
 */
proto.no.jotta.openapi.LoginFlowRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.LoginFlowRef;
  return proto.no.jotta.openapi.LoginFlowRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.LoginFlowRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.LoginFlowRef}
 */
proto.no.jotta.openapi.LoginFlowRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.LoginFlowRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.LoginFlowRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.LoginFlowRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string login_token = 1;
 * @return {string}
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.getLoginToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.LoginFlowRef} returns this
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.setLoginToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error_message = 2;
 * @return {string}
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.LoginFlowRef} returns this
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.setErrorMessage = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.no.jotta.openapi.LoginFlowRef} returns this
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.clearErrorMessage = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.LoginFlowRef.prototype.hasErrorMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.InstallationCodeRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.InstallationCodeRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.InstallationCodeRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.InstallationCodeRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    installationCode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.InstallationCodeRef}
 */
proto.no.jotta.openapi.InstallationCodeRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.InstallationCodeRef;
  return proto.no.jotta.openapi.InstallationCodeRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.InstallationCodeRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.InstallationCodeRef}
 */
proto.no.jotta.openapi.InstallationCodeRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstallationCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.InstallationCodeRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.InstallationCodeRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.InstallationCodeRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.InstallationCodeRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstallationCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string installation_code = 1;
 * @return {string}
 */
proto.no.jotta.openapi.InstallationCodeRef.prototype.getInstallationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.InstallationCodeRef} returns this
 */
proto.no.jotta.openapi.InstallationCodeRef.prototype.setInstallationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.SupportRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.SupportRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.SupportRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SupportRef.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.SupportRef}
 */
proto.no.jotta.openapi.SupportRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.SupportRef;
  return proto.no.jotta.openapi.SupportRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.SupportRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.SupportRef}
 */
proto.no.jotta.openapi.SupportRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.SupportRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.SupportRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.SupportRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.SupportRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.ContentRef.oneofGroups_ = [[1,12,11,2,3,18,4,5,6,7,8,9,10,13,14,15,16,17,19,20,21,22,23,24,25,26,27]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.ContentRef.RefCase = {
  REF_NOT_SET: 0,
  FILE_OR_FOLDER: 1,
  FILE_REVISION: 12,
  PHOTO: 11,
  PHOTO_IN_ALBUM: 2,
  PHOTO_ALBUM: 3,
  FACE_REF: 18,
  COMMENT: 4,
  TRASH: 5,
  ARCHIVE: 6,
  SYNC_FOLDER: 7,
  SETTINGS: 8,
  PURCHASE: 9,
  PUBLIC_SHARE: 10,
  ORDER: 13,
  EXTERNAL_LINK: 14,
  PHOTOS_REF: 15,
  HELP_ARTICLE: 16,
  FEDERATED_IDENTITY: 17,
  VIPPS_FLOW: 19,
  FAMILY_INVITE: 20,
  VOUCHER: 21,
  PASSWORD_RESET_KEY: 22,
  DEVICE_LOGIN_CODE: 23,
  LOGIN_FLOW_REF: 24,
  INSTALLATION_CODE_REF: 25,
  SUPPORT_REF: 26,
  PAYPAL_FLOW: 27
};

/**
 * @return {proto.no.jotta.openapi.ContentRef.RefCase}
 */
proto.no.jotta.openapi.ContentRef.prototype.getRefCase = function() {
  return /** @type {proto.no.jotta.openapi.ContentRef.RefCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.ContentRef.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.ContentRef.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.ContentRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.ContentRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ContentRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileOrFolder: (f = msg.getFileOrFolder()) && proto.no.jotta.openapi.FileOrFolderRef.toObject(includeInstance, f),
    fileRevision: (f = msg.getFileRevision()) && proto.no.jotta.openapi.FileRevisionRef.toObject(includeInstance, f),
    photo: (f = msg.getPhoto()) && proto.no.jotta.openapi.PhotoRef.toObject(includeInstance, f),
    photoInAlbum: (f = msg.getPhotoInAlbum()) && proto.no.jotta.openapi.PhotoInAlbumRef.toObject(includeInstance, f),
    photoAlbum: (f = msg.getPhotoAlbum()) && proto.no.jotta.openapi.PhotoAlbumRef.toObject(includeInstance, f),
    faceRef: (f = msg.getFaceRef()) && proto.no.jotta.openapi.FaceRef.toObject(includeInstance, f),
    comment: (f = msg.getComment()) && proto.no.jotta.openapi.CommentRef.toObject(includeInstance, f),
    trash: (f = msg.getTrash()) && proto.no.jotta.openapi.TrashRef.toObject(includeInstance, f),
    archive: (f = msg.getArchive()) && proto.no.jotta.openapi.ArchiveRef.toObject(includeInstance, f),
    syncFolder: (f = msg.getSyncFolder()) && proto.no.jotta.openapi.SyncFolderRef.toObject(includeInstance, f),
    settings: (f = msg.getSettings()) && proto.no.jotta.openapi.SettingsRef.toObject(includeInstance, f),
    purchase: (f = msg.getPurchase()) && proto.no.jotta.openapi.PurchaseRef.toObject(includeInstance, f),
    publicShare: (f = msg.getPublicShare()) && proto.no.jotta.openapi.PublicShareRef.toObject(includeInstance, f),
    order: (f = msg.getOrder()) && proto.no.jotta.openapi.OrderRef.toObject(includeInstance, f),
    externalLink: (f = msg.getExternalLink()) && proto.no.jotta.openapi.ExternalLinkRef.toObject(includeInstance, f),
    photosRef: (f = msg.getPhotosRef()) && proto.no.jotta.openapi.PhotosRef.toObject(includeInstance, f),
    helpArticle: (f = msg.getHelpArticle()) && proto.no.jotta.openapi.HelpArticle.toObject(includeInstance, f),
    federatedIdentity: (f = msg.getFederatedIdentity()) && proto.no.jotta.openapi.FederatedIdentityRef.toObject(includeInstance, f),
    vippsFlow: (f = msg.getVippsFlow()) && proto.no.jotta.openapi.VippsFlowRef.toObject(includeInstance, f),
    familyInvite: (f = msg.getFamilyInvite()) && proto.no.jotta.openapi.FamilyInviteRef.toObject(includeInstance, f),
    voucher: (f = msg.getVoucher()) && proto.no.jotta.openapi.VoucherRef.toObject(includeInstance, f),
    passwordResetKey: (f = msg.getPasswordResetKey()) && proto.no.jotta.openapi.PasswordResetKeyRef.toObject(includeInstance, f),
    deviceLoginCode: (f = msg.getDeviceLoginCode()) && proto.no.jotta.openapi.DeviceLoginCodeRef.toObject(includeInstance, f),
    loginFlowRef: (f = msg.getLoginFlowRef()) && proto.no.jotta.openapi.LoginFlowRef.toObject(includeInstance, f),
    installationCodeRef: (f = msg.getInstallationCodeRef()) && proto.no.jotta.openapi.InstallationCodeRef.toObject(includeInstance, f),
    supportRef: (f = msg.getSupportRef()) && proto.no.jotta.openapi.SupportRef.toObject(includeInstance, f),
    paypalFlow: (f = msg.getPaypalFlow()) && proto.no.jotta.openapi.PayPalFlowRef.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.ContentRef}
 */
proto.no.jotta.openapi.ContentRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.ContentRef;
  return proto.no.jotta.openapi.ContentRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.ContentRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.ContentRef}
 */
proto.no.jotta.openapi.ContentRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.FileOrFolderRef;
      reader.readMessage(value,proto.no.jotta.openapi.FileOrFolderRef.deserializeBinaryFromReader);
      msg.setFileOrFolder(value);
      break;
    case 12:
      var value = new proto.no.jotta.openapi.FileRevisionRef;
      reader.readMessage(value,proto.no.jotta.openapi.FileRevisionRef.deserializeBinaryFromReader);
      msg.setFileRevision(value);
      break;
    case 11:
      var value = new proto.no.jotta.openapi.PhotoRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotoRef.deserializeBinaryFromReader);
      msg.setPhoto(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.PhotoInAlbumRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotoInAlbumRef.deserializeBinaryFromReader);
      msg.setPhotoInAlbum(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.PhotoAlbumRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotoAlbumRef.deserializeBinaryFromReader);
      msg.setPhotoAlbum(value);
      break;
    case 18:
      var value = new proto.no.jotta.openapi.FaceRef;
      reader.readMessage(value,proto.no.jotta.openapi.FaceRef.deserializeBinaryFromReader);
      msg.setFaceRef(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.CommentRef;
      reader.readMessage(value,proto.no.jotta.openapi.CommentRef.deserializeBinaryFromReader);
      msg.setComment(value);
      break;
    case 5:
      var value = new proto.no.jotta.openapi.TrashRef;
      reader.readMessage(value,proto.no.jotta.openapi.TrashRef.deserializeBinaryFromReader);
      msg.setTrash(value);
      break;
    case 6:
      var value = new proto.no.jotta.openapi.ArchiveRef;
      reader.readMessage(value,proto.no.jotta.openapi.ArchiveRef.deserializeBinaryFromReader);
      msg.setArchive(value);
      break;
    case 7:
      var value = new proto.no.jotta.openapi.SyncFolderRef;
      reader.readMessage(value,proto.no.jotta.openapi.SyncFolderRef.deserializeBinaryFromReader);
      msg.setSyncFolder(value);
      break;
    case 8:
      var value = new proto.no.jotta.openapi.SettingsRef;
      reader.readMessage(value,proto.no.jotta.openapi.SettingsRef.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 9:
      var value = new proto.no.jotta.openapi.PurchaseRef;
      reader.readMessage(value,proto.no.jotta.openapi.PurchaseRef.deserializeBinaryFromReader);
      msg.setPurchase(value);
      break;
    case 10:
      var value = new proto.no.jotta.openapi.PublicShareRef;
      reader.readMessage(value,proto.no.jotta.openapi.PublicShareRef.deserializeBinaryFromReader);
      msg.setPublicShare(value);
      break;
    case 13:
      var value = new proto.no.jotta.openapi.OrderRef;
      reader.readMessage(value,proto.no.jotta.openapi.OrderRef.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 14:
      var value = new proto.no.jotta.openapi.ExternalLinkRef;
      reader.readMessage(value,proto.no.jotta.openapi.ExternalLinkRef.deserializeBinaryFromReader);
      msg.setExternalLink(value);
      break;
    case 15:
      var value = new proto.no.jotta.openapi.PhotosRef;
      reader.readMessage(value,proto.no.jotta.openapi.PhotosRef.deserializeBinaryFromReader);
      msg.setPhotosRef(value);
      break;
    case 16:
      var value = new proto.no.jotta.openapi.HelpArticle;
      reader.readMessage(value,proto.no.jotta.openapi.HelpArticle.deserializeBinaryFromReader);
      msg.setHelpArticle(value);
      break;
    case 17:
      var value = new proto.no.jotta.openapi.FederatedIdentityRef;
      reader.readMessage(value,proto.no.jotta.openapi.FederatedIdentityRef.deserializeBinaryFromReader);
      msg.setFederatedIdentity(value);
      break;
    case 19:
      var value = new proto.no.jotta.openapi.VippsFlowRef;
      reader.readMessage(value,proto.no.jotta.openapi.VippsFlowRef.deserializeBinaryFromReader);
      msg.setVippsFlow(value);
      break;
    case 20:
      var value = new proto.no.jotta.openapi.FamilyInviteRef;
      reader.readMessage(value,proto.no.jotta.openapi.FamilyInviteRef.deserializeBinaryFromReader);
      msg.setFamilyInvite(value);
      break;
    case 21:
      var value = new proto.no.jotta.openapi.VoucherRef;
      reader.readMessage(value,proto.no.jotta.openapi.VoucherRef.deserializeBinaryFromReader);
      msg.setVoucher(value);
      break;
    case 22:
      var value = new proto.no.jotta.openapi.PasswordResetKeyRef;
      reader.readMessage(value,proto.no.jotta.openapi.PasswordResetKeyRef.deserializeBinaryFromReader);
      msg.setPasswordResetKey(value);
      break;
    case 23:
      var value = new proto.no.jotta.openapi.DeviceLoginCodeRef;
      reader.readMessage(value,proto.no.jotta.openapi.DeviceLoginCodeRef.deserializeBinaryFromReader);
      msg.setDeviceLoginCode(value);
      break;
    case 24:
      var value = new proto.no.jotta.openapi.LoginFlowRef;
      reader.readMessage(value,proto.no.jotta.openapi.LoginFlowRef.deserializeBinaryFromReader);
      msg.setLoginFlowRef(value);
      break;
    case 25:
      var value = new proto.no.jotta.openapi.InstallationCodeRef;
      reader.readMessage(value,proto.no.jotta.openapi.InstallationCodeRef.deserializeBinaryFromReader);
      msg.setInstallationCodeRef(value);
      break;
    case 26:
      var value = new proto.no.jotta.openapi.SupportRef;
      reader.readMessage(value,proto.no.jotta.openapi.SupportRef.deserializeBinaryFromReader);
      msg.setSupportRef(value);
      break;
    case 27:
      var value = new proto.no.jotta.openapi.PayPalFlowRef;
      reader.readMessage(value,proto.no.jotta.openapi.PayPalFlowRef.deserializeBinaryFromReader);
      msg.setPaypalFlow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.ContentRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.ContentRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.ContentRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ContentRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileOrFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.FileOrFolderRef.serializeBinaryToWriter
    );
  }
  f = message.getFileRevision();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.no.jotta.openapi.FileRevisionRef.serializeBinaryToWriter
    );
  }
  f = message.getPhoto();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.no.jotta.openapi.PhotoRef.serializeBinaryToWriter
    );
  }
  f = message.getPhotoInAlbum();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.PhotoInAlbumRef.serializeBinaryToWriter
    );
  }
  f = message.getPhotoAlbum();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.PhotoAlbumRef.serializeBinaryToWriter
    );
  }
  f = message.getFaceRef();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.no.jotta.openapi.FaceRef.serializeBinaryToWriter
    );
  }
  f = message.getComment();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.no.jotta.openapi.CommentRef.serializeBinaryToWriter
    );
  }
  f = message.getTrash();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.no.jotta.openapi.TrashRef.serializeBinaryToWriter
    );
  }
  f = message.getArchive();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.no.jotta.openapi.ArchiveRef.serializeBinaryToWriter
    );
  }
  f = message.getSyncFolder();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.no.jotta.openapi.SyncFolderRef.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.no.jotta.openapi.SettingsRef.serializeBinaryToWriter
    );
  }
  f = message.getPurchase();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.no.jotta.openapi.PurchaseRef.serializeBinaryToWriter
    );
  }
  f = message.getPublicShare();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.no.jotta.openapi.PublicShareRef.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.no.jotta.openapi.OrderRef.serializeBinaryToWriter
    );
  }
  f = message.getExternalLink();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.no.jotta.openapi.ExternalLinkRef.serializeBinaryToWriter
    );
  }
  f = message.getPhotosRef();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.no.jotta.openapi.PhotosRef.serializeBinaryToWriter
    );
  }
  f = message.getHelpArticle();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.no.jotta.openapi.HelpArticle.serializeBinaryToWriter
    );
  }
  f = message.getFederatedIdentity();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.no.jotta.openapi.FederatedIdentityRef.serializeBinaryToWriter
    );
  }
  f = message.getVippsFlow();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.no.jotta.openapi.VippsFlowRef.serializeBinaryToWriter
    );
  }
  f = message.getFamilyInvite();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.no.jotta.openapi.FamilyInviteRef.serializeBinaryToWriter
    );
  }
  f = message.getVoucher();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.no.jotta.openapi.VoucherRef.serializeBinaryToWriter
    );
  }
  f = message.getPasswordResetKey();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.no.jotta.openapi.PasswordResetKeyRef.serializeBinaryToWriter
    );
  }
  f = message.getDeviceLoginCode();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.no.jotta.openapi.DeviceLoginCodeRef.serializeBinaryToWriter
    );
  }
  f = message.getLoginFlowRef();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.no.jotta.openapi.LoginFlowRef.serializeBinaryToWriter
    );
  }
  f = message.getInstallationCodeRef();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.no.jotta.openapi.InstallationCodeRef.serializeBinaryToWriter
    );
  }
  f = message.getSupportRef();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.no.jotta.openapi.SupportRef.serializeBinaryToWriter
    );
  }
  f = message.getPaypalFlow();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.no.jotta.openapi.PayPalFlowRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional FileOrFolderRef file_or_folder = 1;
 * @return {?proto.no.jotta.openapi.FileOrFolderRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getFileOrFolder = function() {
  return /** @type{?proto.no.jotta.openapi.FileOrFolderRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.FileOrFolderRef, 1));
};


/**
 * @param {?proto.no.jotta.openapi.FileOrFolderRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setFileOrFolder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearFileOrFolder = function() {
  return this.setFileOrFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasFileOrFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FileRevisionRef file_revision = 12;
 * @return {?proto.no.jotta.openapi.FileRevisionRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getFileRevision = function() {
  return /** @type{?proto.no.jotta.openapi.FileRevisionRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.FileRevisionRef, 12));
};


/**
 * @param {?proto.no.jotta.openapi.FileRevisionRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setFileRevision = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearFileRevision = function() {
  return this.setFileRevision(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasFileRevision = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional PhotoRef photo = 11;
 * @return {?proto.no.jotta.openapi.PhotoRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPhoto = function() {
  return /** @type{?proto.no.jotta.openapi.PhotoRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotoRef, 11));
};


/**
 * @param {?proto.no.jotta.openapi.PhotoRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPhoto = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPhoto = function() {
  return this.setPhoto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPhoto = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional PhotoInAlbumRef photo_in_album = 2;
 * @return {?proto.no.jotta.openapi.PhotoInAlbumRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPhotoInAlbum = function() {
  return /** @type{?proto.no.jotta.openapi.PhotoInAlbumRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotoInAlbumRef, 2));
};


/**
 * @param {?proto.no.jotta.openapi.PhotoInAlbumRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPhotoInAlbum = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPhotoInAlbum = function() {
  return this.setPhotoInAlbum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPhotoInAlbum = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PhotoAlbumRef photo_album = 3;
 * @return {?proto.no.jotta.openapi.PhotoAlbumRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPhotoAlbum = function() {
  return /** @type{?proto.no.jotta.openapi.PhotoAlbumRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotoAlbumRef, 3));
};


/**
 * @param {?proto.no.jotta.openapi.PhotoAlbumRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPhotoAlbum = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPhotoAlbum = function() {
  return this.setPhotoAlbum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPhotoAlbum = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional FaceRef face_ref = 18;
 * @return {?proto.no.jotta.openapi.FaceRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getFaceRef = function() {
  return /** @type{?proto.no.jotta.openapi.FaceRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.FaceRef, 18));
};


/**
 * @param {?proto.no.jotta.openapi.FaceRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setFaceRef = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearFaceRef = function() {
  return this.setFaceRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasFaceRef = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional CommentRef comment = 4;
 * @return {?proto.no.jotta.openapi.CommentRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getComment = function() {
  return /** @type{?proto.no.jotta.openapi.CommentRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.CommentRef, 4));
};


/**
 * @param {?proto.no.jotta.openapi.CommentRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setComment = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearComment = function() {
  return this.setComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasComment = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TrashRef trash = 5;
 * @return {?proto.no.jotta.openapi.TrashRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getTrash = function() {
  return /** @type{?proto.no.jotta.openapi.TrashRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.TrashRef, 5));
};


/**
 * @param {?proto.no.jotta.openapi.TrashRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setTrash = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearTrash = function() {
  return this.setTrash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasTrash = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ArchiveRef archive = 6;
 * @return {?proto.no.jotta.openapi.ArchiveRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getArchive = function() {
  return /** @type{?proto.no.jotta.openapi.ArchiveRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.ArchiveRef, 6));
};


/**
 * @param {?proto.no.jotta.openapi.ArchiveRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setArchive = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearArchive = function() {
  return this.setArchive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasArchive = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SyncFolderRef sync_folder = 7;
 * @return {?proto.no.jotta.openapi.SyncFolderRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getSyncFolder = function() {
  return /** @type{?proto.no.jotta.openapi.SyncFolderRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.SyncFolderRef, 7));
};


/**
 * @param {?proto.no.jotta.openapi.SyncFolderRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setSyncFolder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearSyncFolder = function() {
  return this.setSyncFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasSyncFolder = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SettingsRef settings = 8;
 * @return {?proto.no.jotta.openapi.SettingsRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getSettings = function() {
  return /** @type{?proto.no.jotta.openapi.SettingsRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.SettingsRef, 8));
};


/**
 * @param {?proto.no.jotta.openapi.SettingsRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setSettings = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional PurchaseRef purchase = 9;
 * @return {?proto.no.jotta.openapi.PurchaseRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPurchase = function() {
  return /** @type{?proto.no.jotta.openapi.PurchaseRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PurchaseRef, 9));
};


/**
 * @param {?proto.no.jotta.openapi.PurchaseRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPurchase = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPurchase = function() {
  return this.setPurchase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPurchase = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PublicShareRef public_share = 10;
 * @return {?proto.no.jotta.openapi.PublicShareRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPublicShare = function() {
  return /** @type{?proto.no.jotta.openapi.PublicShareRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PublicShareRef, 10));
};


/**
 * @param {?proto.no.jotta.openapi.PublicShareRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPublicShare = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPublicShare = function() {
  return this.setPublicShare(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPublicShare = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional OrderRef order = 13;
 * @return {?proto.no.jotta.openapi.OrderRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getOrder = function() {
  return /** @type{?proto.no.jotta.openapi.OrderRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.OrderRef, 13));
};


/**
 * @param {?proto.no.jotta.openapi.OrderRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setOrder = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ExternalLinkRef external_link = 14;
 * @return {?proto.no.jotta.openapi.ExternalLinkRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getExternalLink = function() {
  return /** @type{?proto.no.jotta.openapi.ExternalLinkRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.ExternalLinkRef, 14));
};


/**
 * @param {?proto.no.jotta.openapi.ExternalLinkRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setExternalLink = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearExternalLink = function() {
  return this.setExternalLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasExternalLink = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional PhotosRef photos_ref = 15;
 * @return {?proto.no.jotta.openapi.PhotosRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPhotosRef = function() {
  return /** @type{?proto.no.jotta.openapi.PhotosRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PhotosRef, 15));
};


/**
 * @param {?proto.no.jotta.openapi.PhotosRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPhotosRef = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPhotosRef = function() {
  return this.setPhotosRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPhotosRef = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional HelpArticle help_article = 16;
 * @return {?proto.no.jotta.openapi.HelpArticle}
 */
proto.no.jotta.openapi.ContentRef.prototype.getHelpArticle = function() {
  return /** @type{?proto.no.jotta.openapi.HelpArticle} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.HelpArticle, 16));
};


/**
 * @param {?proto.no.jotta.openapi.HelpArticle|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setHelpArticle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearHelpArticle = function() {
  return this.setHelpArticle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasHelpArticle = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional FederatedIdentityRef federated_identity = 17;
 * @return {?proto.no.jotta.openapi.FederatedIdentityRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getFederatedIdentity = function() {
  return /** @type{?proto.no.jotta.openapi.FederatedIdentityRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.FederatedIdentityRef, 17));
};


/**
 * @param {?proto.no.jotta.openapi.FederatedIdentityRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setFederatedIdentity = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearFederatedIdentity = function() {
  return this.setFederatedIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasFederatedIdentity = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional VippsFlowRef vipps_flow = 19;
 * @return {?proto.no.jotta.openapi.VippsFlowRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getVippsFlow = function() {
  return /** @type{?proto.no.jotta.openapi.VippsFlowRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.VippsFlowRef, 19));
};


/**
 * @param {?proto.no.jotta.openapi.VippsFlowRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setVippsFlow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearVippsFlow = function() {
  return this.setVippsFlow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasVippsFlow = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional FamilyInviteRef family_invite = 20;
 * @return {?proto.no.jotta.openapi.FamilyInviteRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getFamilyInvite = function() {
  return /** @type{?proto.no.jotta.openapi.FamilyInviteRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.FamilyInviteRef, 20));
};


/**
 * @param {?proto.no.jotta.openapi.FamilyInviteRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setFamilyInvite = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearFamilyInvite = function() {
  return this.setFamilyInvite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasFamilyInvite = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional VoucherRef voucher = 21;
 * @return {?proto.no.jotta.openapi.VoucherRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getVoucher = function() {
  return /** @type{?proto.no.jotta.openapi.VoucherRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.VoucherRef, 21));
};


/**
 * @param {?proto.no.jotta.openapi.VoucherRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setVoucher = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearVoucher = function() {
  return this.setVoucher(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasVoucher = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional PasswordResetKeyRef password_reset_key = 22;
 * @return {?proto.no.jotta.openapi.PasswordResetKeyRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPasswordResetKey = function() {
  return /** @type{?proto.no.jotta.openapi.PasswordResetKeyRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PasswordResetKeyRef, 22));
};


/**
 * @param {?proto.no.jotta.openapi.PasswordResetKeyRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPasswordResetKey = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPasswordResetKey = function() {
  return this.setPasswordResetKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPasswordResetKey = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional DeviceLoginCodeRef device_login_code = 23;
 * @return {?proto.no.jotta.openapi.DeviceLoginCodeRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getDeviceLoginCode = function() {
  return /** @type{?proto.no.jotta.openapi.DeviceLoginCodeRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.DeviceLoginCodeRef, 23));
};


/**
 * @param {?proto.no.jotta.openapi.DeviceLoginCodeRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setDeviceLoginCode = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearDeviceLoginCode = function() {
  return this.setDeviceLoginCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasDeviceLoginCode = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional LoginFlowRef login_flow_ref = 24;
 * @return {?proto.no.jotta.openapi.LoginFlowRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getLoginFlowRef = function() {
  return /** @type{?proto.no.jotta.openapi.LoginFlowRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.LoginFlowRef, 24));
};


/**
 * @param {?proto.no.jotta.openapi.LoginFlowRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setLoginFlowRef = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearLoginFlowRef = function() {
  return this.setLoginFlowRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasLoginFlowRef = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional InstallationCodeRef installation_code_ref = 25;
 * @return {?proto.no.jotta.openapi.InstallationCodeRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getInstallationCodeRef = function() {
  return /** @type{?proto.no.jotta.openapi.InstallationCodeRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.InstallationCodeRef, 25));
};


/**
 * @param {?proto.no.jotta.openapi.InstallationCodeRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setInstallationCodeRef = function(value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearInstallationCodeRef = function() {
  return this.setInstallationCodeRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasInstallationCodeRef = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional SupportRef support_ref = 26;
 * @return {?proto.no.jotta.openapi.SupportRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getSupportRef = function() {
  return /** @type{?proto.no.jotta.openapi.SupportRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.SupportRef, 26));
};


/**
 * @param {?proto.no.jotta.openapi.SupportRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setSupportRef = function(value) {
  return jspb.Message.setOneofWrapperField(this, 26, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearSupportRef = function() {
  return this.setSupportRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasSupportRef = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional PayPalFlowRef paypal_flow = 27;
 * @return {?proto.no.jotta.openapi.PayPalFlowRef}
 */
proto.no.jotta.openapi.ContentRef.prototype.getPaypalFlow = function() {
  return /** @type{?proto.no.jotta.openapi.PayPalFlowRef} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.PayPalFlowRef, 27));
};


/**
 * @param {?proto.no.jotta.openapi.PayPalFlowRef|undefined} value
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
*/
proto.no.jotta.openapi.ContentRef.prototype.setPaypalFlow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.no.jotta.openapi.ContentRef.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.ContentRef} returns this
 */
proto.no.jotta.openapi.ContentRef.prototype.clearPaypalFlow = function() {
  return this.setPaypalFlow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.ContentRef.prototype.hasPaypalFlow = function() {
  return jspb.Message.getField(this, 27) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.ContentRefs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.ContentRefs.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.ContentRefs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.ContentRefs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ContentRefs.toObject = function(includeInstance, msg) {
  var f, obj = {
    refList: jspb.Message.toObjectList(msg.getRefList(),
    proto.no.jotta.openapi.ContentRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.ContentRefs}
 */
proto.no.jotta.openapi.ContentRefs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.ContentRefs;
  return proto.no.jotta.openapi.ContentRefs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.ContentRefs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.ContentRefs}
 */
proto.no.jotta.openapi.ContentRefs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.ContentRef;
      reader.readMessage(value,proto.no.jotta.openapi.ContentRef.deserializeBinaryFromReader);
      msg.addRef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.ContentRefs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.ContentRefs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.ContentRefs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.ContentRefs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRefList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.ContentRef.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ContentRef ref = 1;
 * @return {!Array<!proto.no.jotta.openapi.ContentRef>}
 */
proto.no.jotta.openapi.ContentRefs.prototype.getRefList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.ContentRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.ContentRef, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.ContentRef>} value
 * @return {!proto.no.jotta.openapi.ContentRefs} returns this
*/
proto.no.jotta.openapi.ContentRefs.prototype.setRefList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.ContentRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.ContentRef}
 */
proto.no.jotta.openapi.ContentRefs.prototype.addRef = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.ContentRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.ContentRefs} returns this
 */
proto.no.jotta.openapi.ContentRefs.prototype.clearRefList = function() {
  return this.setRefList([]);
};


goog.object.extend(exports, proto.no.jotta.openapi);
